/* eslint-disable */
import gsap from 'gsap';

let TimelineMax = window.TimelineMax;
let TimelineLite = window.TimelineLite;
let TweenMax = window.TweenMax;
let TweenLite = window.TweenMax;

export {
    TimelineMax,
    TimelineLite,
    TweenMax,
    TweenLite
};



// WEBPACK FOOTER //
// ./src/vendor/index.js